export default __webpack_public_path__ + "static/media/ashutosh.49686268.jpg";